import React, { createContext } from "react";
import useUserApi from "./useUserApi";
import { UserData } from "app/core/common";

interface UserContextValue<T> {
  userInfo: UserData;
  checkingUserInfo: boolean;
  followingListLoaded: boolean;
  followingList: T;
  myNfts: T;
  myNFTsLoading: boolean;
  loadMoreNFTs: () => void;
  updateMyNFTs: () => void;
  updateFollowingList: (list: T) => void;
}

const ConnectUserContext = createContext<UserContextValue<any>>({
  userInfo: null,
  checkingUserInfo: true,
  followingListLoaded: false,
  followingList: [],
  myNfts: [],
  myNFTsLoading: true,
  loadMoreNFTs: () => {},
  updateMyNFTs: () => {},
  updateFollowingList: () => {},
});

export function UserProvider({ children }) {
  let { userInfo, checkingUserInfo, followingListLoaded, followingList, myNfts, myNFTsLoading, loadMoreNFTs, updateMyNFTs, updateFollowingList } =
    useUserApi();

  return (
    <ConnectUserContext.Provider
      value={{
        userInfo,
        checkingUserInfo,
        followingListLoaded,
        followingList,
        myNfts,
        myNFTsLoading,
        loadMoreNFTs,
        updateMyNFTs,
        updateFollowingList
      }}
    >
      {children}
    </ConnectUserContext.Provider>
  );
}

export function useUser() {
  return React.useContext(ConnectUserContext);
}
